__turbopack_context__.v({
  "action": "MobileSideDrawerProfileAction-module-scss-module__mNkF8W__action",
});
